import { ApiService } from "./api.service";
export default class CommentsService extends ApiService {
  namespace = "comments";
  icon = "Comment";
  name = "Type";
  favicon = "Comment";
  Width = 690;
  domain = 0;
  action = "action";
  constructor() {
    super("comments");
  }
}
